// @core/api/endpoints/form/delete_form_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/form';

/**
 * Delete form type
 * Deactivates a form type. Existing forms and submissions of this type are not affected.
 */
export async function DeleteFormType(
  type_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/form-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
